import React, { Component } from 'react'
import { Button, Icon } from 'antd'

import './style.less'

export default class BoardItem extends Component {
  render () {
    return (
      <div className='board-item' >
        <div className='icon'>
          <Icon type={this.props.icon} />
        </div>
        <div className='data'>
          <div className='key'>{this.props.itemKey}</div>
          <div className='value'>{this.props.itemValue}</div>
        </div>
        {
          this.props.buttonLabel ? <div className='action' >
            <Button shape="round" size={'small'} onClick={this.props.clickCallBack} >{this.props.buttonLabel}</Button>
          </div> : null
        }
      </div>
    )
  }
}
